import { ApiError } from './ApiError';

// Superclass for errors involving the backend. So its not the fault of the
// client, but the server itself is not able to provide the information.
// Primarily exists for the BackendServerUnavailableError,
// BackendDatabaseUnavailableError and BackendCiviCrmUnavailableError classes,
// but it might be useful for other things
export class BackendError extends ApiError {
  static errorName = 'BackendError';
}
